import { ReactNode, lazy, Suspense } from "react";
import SiteHeader from "./SiteHeader";
import SiteFooter from "./SiteFooter";
import TopBanner from "./TopBanner";
import GlobalSeoDefaults from "./GlobalSeoDefaults";

const CookieBanner = lazy(() => import("./CookieBanner"));
const NotificationTicker = lazy(() => import("./NotificationTicker"));

interface SiteLayoutProps {
  children: ReactNode;
}

const SiteLayout = ({ children }: SiteLayoutProps) => {
  return (
    <div className="min-h-screen flex flex-col bg-background cyber-grid relative">
      <GlobalSeoDefaults />
      <TopBanner />
      <SiteHeader />
      <main className="flex-1 relative">{children}</main>
      <SiteFooter />
      <Suspense fallback={null}>
        <NotificationTicker />
        <CookieBanner />
      </Suspense>
    </div>
  );
};

export default SiteLayout;
